import React, { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
// import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
// import { Collapse, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
// import countries from "../assets/countries";
import CartItems from "../components/CartItems";
// import CheckoutForm from "../components/CheckoutForm";
import OrderConfirmation from "../components/OrderConfirmation";
import Step1Email from "../components/Step1Email";
import Step2Address from "../components/Step2Address";
import Step3Review from "../components/Step3Review";
import Step4Payment from "../components/Step4Payment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function CartPage({ setCartItems, cartItems, removeFromCart }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [currentStep, setCurrentStep] = useState(1);
  const [email, setEmail] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [agreed, setAgreed] = useState(false);
  const [shippingRate, setShippingRate] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [purchaseCompleted, setPurchaseCompleted] = useState(false);
  const [isOrderConfirmed, setIsOrderConfirmed] = useState(false);
  const navigate = useNavigate();
  const [address, setAddress] = useState({
    name: "",
    line1: "",
    city: "",
    country: "",
    postal_code: "",
  });

  useEffect(() => {
    fetchClientSecret();
  }, [cartItems, address]);

  async function fetchClientSecret() {
    try {
      const response = await fetch(`${API_BASE_URL}/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: cartItems,
          email: email,
          address: address,
        }),
      });

      const { clientSecret } = await response.json();
      setClientSecret(clientSecret);
    } catch (error) {
      console.error("Error fetching client secret:", error);
    }
  }

  const appearance = {
    variables: {
      colorBackground: "#f6f6f6",
      borderWidth: "0px",
    },
  };

  const options = clientSecret ? { clientSecret, appearance } : null;

  const handleQuantityChange = (item, change) => {
    setCartItems((prevCartItems) =>
      prevCartItems.map((cartItem) =>
        cartItem.selectedProduct.id === item.selectedProduct.id &&
        cartItem.selectedSize === item.selectedSize &&
        cartItem.selectedVariation === item.selectedVariation
          ? { ...cartItem, quantity: Math.max(1, cartItem.quantity + change) } // Ensure quantity is at least 1
          : cartItem
      )
    );
  };
  const calculateTotalPrice = (cartItems) => {
    return cartItems.reduce((total, item) => {
      // Destructure necessary properties
      const { selectedProduct, selectedSize, quantity } = item;
      const { prices } = selectedProduct;

      // Find the price object matching the selected size
      const priceObj = prices.find((price) => price.size === selectedSize);

      if (priceObj) {
        // Assuming 'amount' is in GBP
        return total + priceObj.amount * quantity;
      } else {
        console.warn(`Price for size "${selectedSize}" not found.`);
        return total;
      }
    }, 0);
  };
  const totalPrice = calculateTotalPrice(cartItems);

  const handleNextStep = (step) => {
    if (step === 2 && !email.trim()) {
      setValidationErrors({ email: "Email is required" });
      return;
    }

    setValidationErrors({});
    setCurrentStep(step);
  };

  const validateAddress = () => {
    const errors = {};

    if (!address.name) errors.name = "Name is required";
    if (!address.line1) errors.line1 = "Address Line 1 is required";
    if (!address.city) errors.city = "City is required";
    if (!address.country) errors.country = "Country is required";
    if (!address.postal_code) errors.postal_code = "Postal Code is required";

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleGoToStep = (step) => {
    setCurrentStep(step);
  };

  const fetchShippingRate = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/get-shipping-rate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address }),
      });
      const data = await response.json();
      setShippingRate(data.shippingRate);
    } catch (error) {
      console.error("Error fetching shipping rate:", error);
    }
  };

  const handlePurchase = () => {
    navigate("/order-confirmation", {
      state: { cartItems: cartItems, name: address.name },
    });
    setCartItems([]);
  };

  return (
    <div>
      {cartItems.length === 0 ? (
        <div className="alert alert-info text-center m-5" role="alert">
          Your cart is empty.
        </div>
      ) : (
        <div className="CartPage container my-5">
          <div className="row">
            <div className="col-md-6 mb-4">
              {isOrderConfirmed ? (
                <OrderConfirmation />
              ) : (
                <>
                  <Step1Email
                    currentStep={currentStep}
                    handleGoToStep={handleGoToStep}
                    handleNextStep={handleNextStep}
                    email={email}
                    setEmail={setEmail}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors}
                  />
                  <Step2Address
                    currentStep={currentStep}
                    handleGoToStep={handleGoToStep}
                    handleNextStep={handleNextStep}
                    address={address}
                    setAddress={setAddress}
                    validationErrors={validationErrors}
                    setValidationErrors={setValidationErrors}
                    validateAddress={validateAddress}
                    fetchShippingRate={fetchShippingRate}
                    fetchClientSecret={fetchClientSecret}
                  />
                  <Step3Review
                    currentStep={currentStep}
                    handleGoToStep={handleGoToStep}
                    agreed={agreed}
                    setAgreed={setAgreed}
                    handlePurchase={handlePurchase}
                    handleNextStep={handleNextStep}
                  />
                  <Step4Payment
                    setPurchaseCompleted={setPurchaseCompleted}
                    currentStep={currentStep}
                    handleGoToStep={handleGoToStep}
                    clientSecret={clientSecret}
                    stripePromise={stripePromise}
                    options={options}
                    cartItems={cartItems}
                    address={address}
                    purchaseCompleted={purchaseCompleted}
                    email={email}
                    setCartItems={setCartItems}
                  />
                </>
              )}
            </div>
            <div className="col-md-6">
              <CartItems
                cartItems={cartItems}
                removeFromCart={removeFromCart}
                setCartItems={setCartItems}
                shippingRate={shippingRate}
                handleQuantityChange={handleQuantityChange}
                totalPrice={totalPrice}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CartPage;
